import { CourtBookingStore } from "./CourtBookingStore";
import { LoginStore } from "./LoginStore";
import { MatchDetailsStore } from "./matchDetails/MatchDetailsStore";
import { MatchStatsStore } from "./matchDetails/MatchStatsStore";
import { MatchListStore } from "./MatchListStore";
import { OTPStore } from "./OTPStore";
import { PaymentStore } from "./PaymentStore";
import { SectionStore } from "./SectionStore";
import { SelectCircleStore } from "./SelectCircleStore";
import { UserStore } from "./UserStore";

export class RootStore {
  courtBookingStore: CourtBookingStore;
  sectionStore: SectionStore;
  selectCircleStore: SelectCircleStore;
  payemntStore: PaymentStore;
  userStore: UserStore;
  loginStore: LoginStore;
  otpStore: OTPStore;
  matchListStore: MatchListStore;
  matchDetailsStore: MatchDetailsStore;
  matchStatsStore: MatchStatsStore;

  constructor() {
    this.courtBookingStore = new CourtBookingStore(this);
    this.sectionStore = new SectionStore(this);
    this.selectCircleStore = new SelectCircleStore(this);
    this.payemntStore = new PaymentStore(this);
    this.userStore = new UserStore(this);
    this.loginStore = new LoginStore(this);
    this.otpStore = new OTPStore(this);
    this.matchDetailsStore = new MatchDetailsStore(this);
    this.matchStatsStore = new MatchStatsStore(this);
    this.matchListStore = new MatchListStore(this);
  }
}

// Create a single instance of the store
const rootStore = new RootStore();
export default rootStore;
